import AttachmentsModule from './attachments.module'

export default AttachmentsModule
